import React from 'react'
import { General } from "../tools/styles"
import FloatCard from "./ui/FloatCard";
import { theme } from "../theme";
import RenderIf from '../components/RenderIf'

const Criteria = ({
    low = "",
    high = '',
    units='',
    type='',
    just = '',
    handleChange = function () {
      console.log("no function defined");
    },
}) => {
  return (
    <General.BlockContainer>
    <General.Block>
      <FloatCard width="300px">
        <General.InputCont>
          <General.Input
          className='input'
            type="number"
            name="criteriaLow"
            value={low}
            onChange={handleChange}
            placeholder=" "
            required
          />
          <General.Label className='placeholder'>Low</General.Label>
        </General.InputCont>
        <General.InputCont>
          <General.Input
          className='input'
            type="number"
            name="criteriaHigh"
            value={high}
            onChange={handleChange}
            placeholder=" "
            required
          />
          <General.Label className='placeholder'>High</General.Label>
        </General.InputCont>
        <RenderIf isTrue={units.length > 0}>
        <General.InputCont>
          <span>Units: {units}</span>
        </General.InputCont>
        </RenderIf>
        <RenderIf isTrue={units.length === 0}
        >
          <General.InputCont>
          <p>Units will carry down from the current or most recent measurement.  Please fill that section out first.</p>
          </General.InputCont>
        </RenderIf>
        <General.InputCont>
          <span>Type</span>
          <General.Select
            name="criteriaType"
            value={type}
            onChange={handleChange}
            required
          >
            <option value="">-- Choose one</option>
            {["Quality", "Reference", "Target"].map((method, i) => (
              <option key={i} value={method}>
                {method}
              </option>
            ))}
          </General.Select>
        </General.InputCont>
        <General.InputCont>
          <p>
            Types of criteria:
            <li>
              "Quality" represents thresholds of optimum levels of function
              that have been peer-reviewed or otherwise published in a
              high-standard format.
            </li>
            <li>
              "Reference" represents thresholds based on distributions of
              data from representative sites (e.g. similar in salinity,
              tidal range, habitat type).
            </li>
            <li>
              "Target" represents a specific metric value or range that the
              user requires or desires at the site.
            </li>
          </p>
        </General.InputCont>
        <General.InputCont margin='0 1rem'>
          <span >
            Justification
          </span>
        </General.InputCont>
        <General.InputCont margin='0 1rem'>
          <General.Text
          className='input'
            name="criteriaJust"
            value={just}
            onChange={handleChange}
            placeholder=' '
            required
          ></General.Text>
          <General.Label className='placeholder' >Criteria source?</General.Label>
        </General.InputCont>
        <General.InputCont>
          <p>You can drag the lower right corner to make more room.</p>
        </General.InputCont>
      </FloatCard>
    </General.Block>
    <General.Block color={theme.colors.grey4}>
      <div>
        <h2>Reference Criteria</h2>
        <General.LimitText width='250px'>
          A range of values representing a healthy, sustainable location not
          in need of outside intervention.
        </General.LimitText>
      </div>
    </General.Block>
  </General.BlockContainer>
  )
}

export default Criteria